module.exports = __webpack_public_path__ + "static/media/hero.259dec6c.jpg";